import { useEffect, useRef, useState } from 'react';
import { DetailSwitchPage } from './detail-switch-page';
import { ListPage } from './list-page';
import ErrorPage from './error-page';
import Switch from 'components/switch';

import { useSaveParamsURL } from 'hoc/useSaveParamsURL';
import { useControlList } from 'hoc/useControlList';
import { useNeedResizeIframe } from 'hoc/useNeedResizeIframe';
import { useControlDetail } from 'hoc/useControlDetail';

import { takeParamsURL } from 'functions/takeParams';
import { getEmailComunication } from 'functions/getEmailComunication';

const footer = {
  comunication: {
    en: 'ZARA PR & COMMUNICATIONS',
    es: 'ZARA CONTACTO PR & COMUNICACIÓN',
  },
  last: {
    en: '*News media enquiries only.',
    es: '*Exclusivo para peticiones de prensa.',
  },
};

export const ContainerPage = () => {
  const targetRef = useRef();
  const [activeSwitch, setActiveSwitch] = useState(false);
  const isShowroom = useRef(false);
  const [showError, setShowError] = useState(false);

  const handleShowError = (value) => {
    setShowError(value);
  };

  //HOC SAVE PARAMS URL
  const { countryIso, languageIso, detailId, showDraftMode, originURL, modifyParams, setDetailId, darkMode } =
    useSaveParamsURL();

  //HOC LIST
  const { list, page, setPage, limit, haveMoreElemets, handleLoadList } = useControlList(handleShowError);

  //HOC DETAIL
  const { showDetail, detail, handleLoadDetail, handleClickDetail, handleResetDetail } =
    useControlDetail(handleShowError);

  //HOC MODIFICAR TAMAÑO IFRAME
  const { handleResizeIframe } = useNeedResizeIframe();

  //CARGA INICIAL
  useEffect(() => {
    const { countryIsoParam, languageIsoParam, detailIdParam, showDraftModeParam, originURLParam, darkModeParam } =
      takeParamsURL();

    let finalOriginUrlParam = originURLParam;
    let finalLanguageIsoParam = languageIsoParam;
    let finalDarkModeParam = darkModeParam;
    let cargoDatos = false;

    window.parent.addEventListener('popstate', function () {
      if (document.referrer) {
        window.parent.location.reload();
      } else {
        window.location.reload();
      }
    });

    //Carga datos showroom
    window.onmessage = function (e) {
      if (e.data.name === 'config') {
        isShowroom.current = true;
        finalOriginUrlParam = e.data.data.path;
        finalLanguageIsoParam = e.data.data.language;
        finalDarkModeParam = e.data.data.darkMode;
        if (finalDarkModeParam) {
          document.body.classList.add('darkMode');
        }

        handleLoadList(
          finalOriginUrlParam,
          isShowroom.current,
          countryIsoParam,
          finalLanguageIsoParam,
          page,
          limit,
          false,
          true,
        );
        cargoDatos = true;

        modifyParams(
          countryIsoParam,
          finalLanguageIsoParam,
          detailIdParam,
          isShowroom.current ? true : showDraftModeParam,
          finalOriginUrlParam,
          finalDarkModeParam,
        );
      }
    };

    //Carga datos normal
    if (!cargoDatos) {
      if (finalDarkModeParam) {
        document.body.classList.add('darkMode');
      }
      handleLoadContent(detailIdParam, finalOriginUrlParam, countryIsoParam, languageIsoParam);

      modifyParams(
        countryIsoParam,
        finalLanguageIsoParam,
        detailIdParam,
        isShowroom.current ? true : showDraftModeParam,
        finalOriginUrlParam,
        finalDarkModeParam,
      );
    }
  }, []);

  const handleLoadContent = (detailIdParam, finalOriginUrlParam, countryIsoParam, languageIsoParam) => {
    if (detailIdParam !== '') {
      handleLoadDetail(
        detailIdParam,
        finalOriginUrlParam,
        isShowroom.current,
        countryIsoParam,
        languageIsoParam,
        activeSwitch,
      );
    } else {
      handleLoadList(
        finalOriginUrlParam,
        isShowroom.current,
        countryIsoParam,
        languageIsoParam,
        page,
        limit,
        false,
        false,
      );
    }
  };

  const handleLoad = () => {
    if (isShowroom.current) {
      window.top.postMessage({ name: 'height', height: targetRef.current.clientHeight + 100 }, '*');
    } else {
      handleResizeIframe(targetRef.current.clientHeight, detail?.isNewStructureId);
    }
  };

  const handleClickPlus = () => {
    if (haveMoreElemets) {
      setPage(page + 1);
      handleLoadList(originURL, isShowroom.current, countryIso, languageIso, page + 1, limit, false, activeSwitch);
    }
  };

  const handleBack = () => {
    if (document.referrer) {
      const url = new URL(window.parent.location.href);
      url.searchParams.delete('detailid');
      window.parent.history.pushState(null, null, url);
    } else {
      const url = new URL(window.parent.location.href);
      url.searchParams.delete('detailid');
      window.history.pushState(null, null, url);
    }

    handleResetDetail();
    if (detailId !== '') {
      setDetailId('');

      handleLoadList(originURL, isShowroom.current, countryIso, languageIso, page, limit, false, activeSwitch);
    }
  };

  const handleOnChangeSwitch = () => {
    handleLoadList(originURL, isShowroom.current, countryIso, languageIso, page, limit, true, !activeSwitch);
    setActiveSwitch(!activeSwitch);
  };

  const getFooter = (type) => {
    if (languageIso === 'es' || (countryIso === 'es' && languageIso !== 'en')) {
      return footer[type]['es'];
    } else {
      return footer[type]['en'];
    }
  };

  const getLocaleMapper = () => {
    if (languageIso === 'es' || (countryIso === 'es' && languageIso !== 'en')) {
      return 'es';
    } else {
      return 'en';
    }
  };

  return (
    <div className="containerPage-container" id="news-microsite" ref={targetRef} onLoad={handleLoad}>
      {showError ? (
        <ErrorPage locale={languageIso} />
      ) : !showDetail ? (
        <>
          <p className="principal-title">NEWS</p>
          {showDraftMode && (
            <div className="switch-container">
              <p>{languageIso === 'es' ? 'MOSTRAR CONTENIDO DRAFT:' : 'SHOW CONTENT DRAFT:'}</p>
              <Switch isOn={activeSwitch} handleToggle={handleOnChangeSwitch} />
            </div>
          )}
          <ListPage
            list={list}
            onClickDetail={(e, id) => {
              handleClickDetail(e, id, originURL, isShowroom.current, countryIso, languageIso, activeSwitch);
            }}
            locale={getLocaleMapper()}
            onClickPlus={handleClickPlus}
            showButtonPlus={haveMoreElemets}
            showDraft={activeSwitch}
          />
        </>
      ) : (
        <DetailSwitchPage
          originURL={originURL}
          country={countryIso.toLowerCase()}
          detail={detail}
          locale={getLocaleMapper()}
          onBack={handleBack}
          showDraft={activeSwitch}
          darkMode={darkMode}
          isShowroom={isShowroom.current}
        />
      )}
      <div className="footer-container">
        <div>
          <p>
            {getFooter('comunication')}
            <br />
            <a href={`mailto:${getEmailComunication(countryIso.toLowerCase())}`} className={darkMode ? 'darkMode' : ''}>
              {getEmailComunication(countryIso.toLowerCase())}
            </a>
          </p>
          <p>{getFooter('last')}</p>
        </div>
      </div>
    </div>
  );
};
